import { get } from 'svelte/store'
import {
  computer,
  discard,
  topDiscard,
  updateComputerHand,
  addToDiscard,
  removeFromDiscard,
  removeFromDeck,
} from '../../stores/cards.js'

import {
  targetCard,
  sourceCard,
  zoomDiscard,
  zoomDeck,
  deckCardVisible,
  deckSelected,
  discardSelected,
} from '../../stores/cardPLay'

import { checkForSeries } from '../services'

function computerDiscardClick() {
  let tCard, sCard

  // Select discard as source card
  if (!sourceCard()) {
    discardSelected(true)
    sCard = topDiscard()
    sourceCard(sCard)
    zoomDiscard(true)
    return
  } else {
    sCard = sourceCard()
  }
  if (deckSelected()) {
    if (targetCard()) {
      tCard = targetCard()
      tCard.zoom = false
      targetCard(tCard)
      sCard.handIndex = tCard.handIndex
      sCard.displayClass = 'visible'
      sourceCard(sCard)

      updateComputerHand(tCard.handIndex, tCard)
      updateComputerHand(sCard.handIndex, sCard)
      checkForSeries(1, get(computer), sCard.handIndex)
      addToDiscard(tCard)
    } else {
      addToDiscard(sCard)
    }
    zoomDeck(false)
    deckCardVisible(false)
    removeFromDeck()
  } else if (targetCard()) {
    tCard = targetCard()
    tCard.zoom = false
    targetCard(tCard)

    sCard.handIndex = tCard.handIndex
    sCard.displayClass = 'visible'
    sourceCard(sCard)

    updateComputerHand(tCard.handIndex, tCard)
    updateComputerHand(sCard.handIndex, sCard)
    checkForSeries(1, get(computer), sCard.handIndex)
    removeFromDiscard()
    addToDiscard(tCard)
  }

  zoomDiscard(false)
}  

export { computerDiscardClick }
